import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UserService } from "../services";

@Component({
  template: ''
})
export abstract class UserSettingsBase implements OnInit {
  private _isDirty: boolean = false;
  @Input() title: string = "Unset";
  @Output() isDirtyChanged = new EventEmitter<boolean>();

  ngOnInit(): void {
    // Left blank for implementation by inheriting classes.
  }

  save() {
    // Left blank for implementation by inheriting classes.
  }

  cancel() {
    // Left blank for implementation by inheriting classes.
  }

  public get isDirty(): boolean {
    return this._isDirty;
  }

  protected set isDirty(value: boolean) {
    this._isDirty = value;
    this.isDirtyChanged.emit(value);
  }

}
